export const resolveExists = () => {
    return {
        output_type: 'boolean',
        type: 'exists-condition',
    };
};
//# sourceMappingURL=exists.js.map